import {
  createStore,
  combineReducers,
  applyMiddleware,
  type Store,
  type AnyAction,
} from 'redux'
import {
  useSelector as useReactReduxSelector,
  useDispatch as useReactReduxDispatch,
} from 'react-redux'
import { persistStore } from 'redux-persist'
import {
  thunk,
  type ThunkAction as ReduxThunkAction,
  type ThunkDispatch as ReduxThunkDispatch,
} from 'redux-thunk'
import { composeWithDevTools } from '@redux-devtools/extension'

import config from '../config'
import { key as movesKey, reducer as movesReducer } from '../modules/moves'
import { key as quotesKey, reducer as quotesReducer } from '../modules/quotes'
import { key as graphQlKey, reducer as graphQlReducer } from '../modules/graphQl'
import { key as consentKey, reducer as consentReducer } from '../modules/consent'

const { isProduction } = config

const mainReducer = combineReducers({
  [graphQlKey]: graphQlReducer,
  [movesKey]: movesReducer,
  [quotesKey]: quotesReducer,
  [consentKey]: consentReducer,
})

const middleWares = [
  thunk,
]

let middleware = applyMiddleware(...middleWares)

if (!isProduction) {
  middleware = composeWithDevTools(middleware)
}

export const getStore = (defaultState?: any) => {
  return createStore(mainReducer, defaultState, middleware)
}

const store = getStore()

/* infer store state type */

export type StoreState = ReturnType<typeof store.getState>

/* define thunk types */

export type ThunkAction<ReturnType> = ReduxThunkAction<ReturnType, StoreState, unknown, AnyAction>
export type ThunkDispatch = ReduxThunkDispatch<StoreState, unknown, AnyAction>

export const useDispatch = () => useReactReduxDispatch<ThunkDispatch>()
export const useSelector = useReactReduxSelector

export const persistor = persistStore(store as unknown as Store<any, AnyAction>)
export default store
